import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { Subscriber } from '../models/subscriber.model';

const jsonHttpOptions = {
  headers: new HttpHeaders({
    Accept: 'application/json'
  })
};

@Injectable()
export class SubscriberService {
  private readonly baseUrl: string;

  constructor(private readonly http: HttpClient) {
    this.baseUrl = `${environment.flyLegacyUrl}/api/subscriber`;
  }

  getSubscriberUuid(billingAccountId: string): Observable<string> {
    return this.http
      .get<Subscriber>(`${this.baseUrl}/account/billinguser/${billingAccountId}`, jsonHttpOptions)
      .pipe(map((subscriber: Subscriber) => subscriber.AccountId));
  }
}
